module.exports = __webpack_public_path__ + "static/media/assessment.54a523b9.gif";